const styles = theme => ({
  postContainer: {
    padding: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      display: "inline"
    }
  },
  leftContainer: {
    width: "50%",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "center",
      width: "100%"
    }
  },
  rightContainer: {
    paddingLeft: theme.spacing(2),
    width: "50%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      paddingLeft: 0
    }
  },
  underline: {
    "&:before": {
      borderBottom: `5px solid ${theme.palette.primary.main}`
    },
    "&:after": {
      borderBottom: `5px solid ${theme.palette.primary.main}`
    },
    "&:hover:before": {
      borderBottom: `5px solid ${theme.palette.primary.main}`
    }
  },
  media: {
    width: "100%",
    // maxHeight: "500px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: 4,
    position: "relative"
  },
  image: {
    display: "block",
    width: "100%",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      width: "400px"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  video: {
    width: "100%"
  },
  cropButton: {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1
  },
  cropActionButtons: {
    display: "flex",
    marginTop: -5
  },
  cropActionButton: {
    borderRadius: 0,
    boxShadow: "none",
    width: "100%"
  },

  textFieldContainer: {
    width: "100%"
  },
  textArea: {
    margin: 0,
    padding: theme.spacing(1.5),
    backgroundColor: "white"
  },
  switchText: {
    color: theme.palette.primary.default,
    fontWeight: "bold"
  },
  networksContainer: {
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  networkContainer: {
    width: "30%",
    marginBottom: theme.spacing(2)
  },
  checkboxContainer: {
    // marginLeft: "11px",
    "&.Mui-disabled": {
      background: "rgba(100, 100, 100, 0.2)",
      color: "#aaa !important"
    }
  },
  labelMargin: {
    marginRight: "6px"
  },
  repeatIcon: {
    width: "22px",
    padding: "0px"
  },
  iconColor: {
    color: theme.palette.alt.main
  },
  twitterCharactersCounter: {
    marginTop: theme.spacing(1)
  },
  greenCharacter: {
    color: "#40BE5E",
    fontSize: "10px",
    fontWeight: "bold"
  },
  redCharacter: {
    color: theme.palette.warning.main
  },
  legend: {
    color: theme.palette.primary.default,
    fontWeight: "700",
    fontSize: "18px"
  },
  reconnect: {
    color: "#ff0000"
  },
  MuiIcon: {
    root: {
      marginLeft: 0,
      PaddingLeft: 0
    }
  },
  location: {
    margin: 0,
    // marginTop: theme.spacing(-2),
    padding: `${theme.spacing(3)}px 0`,
    width: "100%",
    border: "none",
    fontSize: 12,
    fontWeight: 700,
    outline: "none"
  },
  locationSuggestionContainer: {
    position: "absolute",
    marginTop: theme.spacing(-2),
    width: "100%",
    background: "#fff",
    boxShadow: `4px 3px 3px rgba(0, 0, 0, .3)`,
    zIndex: 5,
    maxWidth: 350
  },
  locationSuggestion: {
    padding: `${theme.spacing(1)}px`,
    borderBottom: `1px solid rgba(0, 0, 0, 0.2)`,
    "&:last-of-type": {
      borderBottom: "none"
    },
    cursor: "pointer"
  },
  locationSuggestionActive: {
    background: "#f1f1f1"
  },
  updateButton: {
    flexBasis: "50%",
    justifyContent: "center",
    display: "flex"
  },
  keyboardPicker: {
    flex: 1,
    "&:nth-of-type(1)": {
      marginRight: "5px"
    },
    "&:nth-of-type(2)": {
      marginLeft: "5px"
    },
    "& > label": {
      color: theme.palette.primary.main
    },
    "& .MuiIconButton-label": {
      color: theme.palette.primary.main
    }
  },
  connectButton: {
    minWidth: "unset",
    width: 42
    // marginLeft: 11
  },
  icon: {},
  tweetDeckIcon: {
    width: 30
  },
  linkedinOrgLabel: {
    "& span": {
      fontSize: 12,
      color: "#001F54"
    }
  },
  thumb: {
    backgroundColor: "#78A1BB"
  },
  track: {
    backgroundColor: "rgb(120,161,187,0.8) !important"
  },
  optionsTitle: {
    fontSize: "19px",
    color: theme.palette.primary.default,
    fontWeight: "bold"
  },
  optionsSubtitle: {
    color: "#777777"
  },
  linkedinCollapse: {
    width: "100%"
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/PublishContainer/steps/PublishPost/styles.js